import $ from 'jquery';
import 'readmore-js';

function textExpand() {
  $('.text-expand').readmore({
    collapsedHeight: 134.4,
    moreLink: '<a href="javascript:void();" class="expand-link">Mehr Erfahren</a>',
    lessLink: '<a href="javascript:void();" class="expand-link expand-link--open">Weniger lesen</a>'
  });
}

export default textExpand;
